import React from 'react';
import { Award, CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function DoSomeMartialArtsWhyTaekwondo() {
  return <section className="py-24 bg-off-white" data-id="element-1012">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1013">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1014">
          <div data-id="element-1015">
            <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1016">
              <Award className="w-3.5 h-3.5" data-id="element-1017" />
              Real Taekwondo
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1018">
              Why Taekwondo at Storm?
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1019">
              Storm teaches Olympic-style Taekwondo — aligned with World
              Taekwondo (WT) and Kukkiwon standards. It's a real, structured
              martial art with belt progression, clear goals, and a global
              community behind it.
            </p>
            <p className="text-lg text-gray-warm mb-8" data-id="element-1020">
              But what makes Storm different is the coaching environment.
              Positive, patient, and built for beginners. Most new students walk
              in having never trained before — and walk out wanting to come
              back.
            </p>
            <ul className="space-y-3" data-id="element-1021">
              {['Olympic-style Taekwondo — real curriculum, real progression', 'Experienced coaches who specialize in beginners', 'A positive, respectful coaching environment', 'Classes for every age — ages 3 through adult'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1022">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-1023" />
                  <span className="text-ink" data-id="element-1024">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-1025">
            <img src={SITE_IMAGES.adultClasses} alt="Storm Taekwondo Olympic-style training" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1026" />
          </div>
        </div>
      </div>
    </section>;
}